import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const bullets = ['Terminás el día mentalmente agotado.', 'Te cuesta desconectar al llegar a casa.', 'Respondés en caliente y después te arrepentís.', 'Aceptás tareas aunque ya estés saturado.', 'Postergás conversaciones incómodas.', 'Te cuesta decir que no.', 'Una discusión puede arruinarte varias horas.', 'Sentís que todo es urgente.', 'El ambiente laboral termina afectando tu energía fuera del trabajo.'];
export function IdentificationSection() {
  return <section className="w-full py-20 md:py-28 px-4" data-id="element-133" data-mp="1p9j57q7unk8e">
      <div className="max-w-4xl mx-auto" data-id="element-134" data-mp="1u7uh06hpg4t9">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-135" data-mp="1u4osotgwh6yl">
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-136" data-mp="5bsg3kezzoey">
            ¿Termina tu jornada…{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-137" data-mp="3rq22xp3a4odm">
              pero tu cabeza sigue trabajando?
            </span>
          </h2>
          <div className="max-w-2xl mx-auto mt-6 space-y-4 text-ink-soft text-base md:text-lg leading-relaxed" data-id="element-138" data-mp="3mt1ux8mvdbjv">
            <p data-id="element-139" data-mp="o7igx4b72er9">
              Hay días en los que el trabajo no termina cuando cerrás la
              computadora, bajás la persiana o termina tu turno.
            </p>
            <p data-id="element-140" data-mp="ea473njs0o7x">
              Te llevás conversaciones a casa. Repasás lo que tendrías que haber
              dicho. Pensás en todo lo que quedó pendiente. Te irritás más
              rápido. Todo parece urgente.
            </p>
            <p className="font-semibold text-ink" data-id="element-141" data-mp="2yz9yk4c28tf7">
              Y al día siguiente volvés a empezar.
            </p>
          </div>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-3" data-id="element-142" data-mp="1m45qep30loqs">
          {bullets.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.04
        }} className="flex items-start gap-3 bg-white border border-line rounded-2xl p-4 shadow-sm" data-id="element-143" data-mp="1q4zepjkdd5k7" data-mpi={i}>
              <span className="flex-shrink-0 w-7 h-7 rounded-full bg-rose/10 flex items-center justify-center mt-0.5" data-id="element-144" data-mp="tg9v9ot3g4w4">
                <XIcon className="w-4 h-4 text-rose" strokeWidth={3} data-id="element-145" data-mp="yb5naoybys98" />
              </span>
              <span className="text-ink text-sm md:text-base" data-id="element-146" data-mp="jic711b8i83i">{b}</span>
            </motion.div>)}
        </div>

        <motion.blockquote initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-white border border-line rounded-3xl p-8 md:p-12 mt-10 text-center shadow-sm" data-id="element-147" data-mp="4tkcu24vxdm2">
          <p className="text-ink text-lg md:text-xl leading-relaxed" data-id="element-148" data-mp="9s3y00bnmldd">
            No siempre podés controlar lo que pasa durante tu jornada.
          </p>
          <p className="font-serif-italic text-rose text-xl md:text-2xl mt-3" data-id="element-149" data-mp="nqbqnw1nr0iq">
            Pero sí podés aprender a manejar mejor cómo lo atravesás.
          </p>
        </motion.blockquote>
      </div>
    </section>;
}